import { useQuery } from '@tanstack/react-query';
import { ResponseObject } from '../../interfaces/App';
import User from '../../interfaces/User';
import { getUser } from '../../services/userService';

interface UserResponse extends Omit<ResponseObject, 'message'> {
  message: User | null;
}

export const useUser = (userId: string | undefined, enabled = true) => {
  return useQuery<ResponseObject, Error, UserResponse>({
    queryKey: ['user', userId],
    queryFn: async (): Promise<ResponseObject> => {
      if (!userId) {
        return { status: 'error', message: null };
      }
      const result = await getUser(userId);
      return result || { status: 'error', message: null };
    },
    enabled: enabled && !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    select: data => ({
      ...data,
      message: data.message as User,
    }),
  });
};
